import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import NavigationIcon from '@material-ui/icons/Navigation';
import { withStyles } from '@material-ui/core/styles';

class DeliveryDialog extends Component {
  renderContent() {
    const { order, onClose, classes } = this.props;

    if (!order) {
      return null;
    }

    const { address } = order;

    const backButton = (
      <Button
        variant="outlined"
        className={classes.button}
        onClick={onClose}
      >
        Zurück
      </Button>
    );

    if (!address) {
      return (
        <div>
          <p>Keine Adresse verfügbar.</p>
          {backButton}
        </div>
      );
    }

    return (
      <div style={{ width: 300 }}>
        <strong>{order.pickupName}</strong>
        <br />
        <strong>{address.companyName}</strong>
        <p>{address.street}</p>
        <p>{address.zip} {address.city}</p>
        <p>Stiege: {address.stairway || '-'} / Stock: {address.floor || '-'} / Tür: {address.door || '-'}</p>

        <p>Telefon: {address.telephone}</p>

        <div style={{ marginTop: 20 }} className="hidePrint">
          {backButton}
          <Button
            target="_blank"
            href={`https://www.google.com/maps/search/?api=1&query=${address.companyName || ''} ${address.street} ${address.zip} ${address.city}`}
            variant="outlined"
            className={classes.buttonLeft}
            onClick={onClose}
          >
            <NavigationIcon />
            Route
          </Button>
        </div>
      </div>
    )
  }
  render() {
    return (
      <Dialog
        classes={{ paper: 'printDialog' }}
        open={this.props.open}
        onClose={this.handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Lieferung</DialogTitle>
        <DialogContent>
          {this.renderContent()}
        </DialogContent>
      </Dialog>
    );
  }
}

const styles = theme => ({
  button: {
    fontSize: theme.order.buttons.fontSize,
    float: 'right',

  },
  buttonLeft: {
    fontSize: theme.order.buttons.fontSize,
    float: 'left',
  },
});


DeliveryDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  order: PropTypes.object,
  onClose: PropTypes.func.isRequired,
};

DeliveryDialog.defaultProps = {
  order: null,
};


export default withStyles(styles)(DeliveryDialog);

